import { lazy } from "react";
import Loadable from "app/components/Loadable";

const MailServerConfigList = Loadable(
  lazy(() => import("./MailServerConfigList")),
);
const MailServerConfigAdd = Loadable(
  lazy(() => import("./MailServerConfigAdd")),
);

const MailServerConfigRoutes = [
  { path: "/config/mail-server-config", element: <MailServerConfigList /> },
  {
    path: "/config/mail-server-config/:mode/:id",
    element: <MailServerConfigAdd />,
  },
];

export default MailServerConfigRoutes;
